import { supabase } from '@/integrations/supabase/client';

export type JobType = 
  | 'deep-research'
  | 'send-vendor-review-email'
  | 'send-vendor-update-email'
  | 'map-integrations';

export async function enqueueJob(job: { type: JobType; payload: any }) {
  const functionMap: Record<JobType, string> = {
    'deep-research': 'deep-research-agent',
    'send-vendor-review-email': 'send-vendor-review',
    'send-vendor-update-email': 'send-vendor-update',
    'map-integrations': 'map-integrations',
  };
  
  const { data, error } = await supabase.functions.invoke(
    functionMap[job.type],
    { body: job.payload }
  );
  
  if (error) throw error;
  return data;
}
